import { useTranslation } from 'react-i18next';
import { GenericSettings } from '../components/GenericSettings';
import { NotificationEntityType } from 'types';
import { translations } from 'app/locales/i18n';

export const PourEventSettings = () => {
  const { t } = useTranslation();
  return (
    <GenericSettings
      entityType={NotificationEntityType.POUR_EVENT}
      header={t(translations.pourEventListing.pourEventListing)}
      label={t(translations.pourEventListing.pourEvents)}
      emptyTableText={t(translations.pourEventListing.noPourEvents)}
    />
  );
};
